
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 34 34","height":"32","width":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('g',{attrs:{"transform":"translate(4 4.5)","fill-rule":"nonzero","fill":"#000"}},[_c('circle',{attrs:{"r":"1.879","cy":"2.12","cx":"7.267","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"2.805","cx":"2.682","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"6.563","cx":"5.388","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"19.065","cx":"5.66","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"15.615","cx":"9.042","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"20.325","cx":"10.571","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"10.66","cx":"16.826","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"8.781","cx":"21.41","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"5.603","cx":"16.826","vector-effect":"non-scaling-stroke"}})])])])
          )
        }
      }
    